import { render, staticRenderFns } from "./LinkPromptModal.vue?vue&type=template&id=973bf518&scoped=true"
import script from "./LinkPromptModal.vue?vue&type=script&lang=js"
export * from "./LinkPromptModal.vue?vue&type=script&lang=js"
import style0 from "./LinkPromptModal.vue?vue&type=style&index=0&id=973bf518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973bf518",
  null
  
)

export default component.exports